import ResetFilterIcon from './component'

export default ResetFilterIcon
